export interface GenerateHolidayChildCareStatementModalData {
    Title: string;
    WorkerId: number;
    WorkerFormId: number;
    FirstName: string;
    LastName: string;
    DateOfBirth: Date;
    Pesel: string;
    IsHolidayChildcareAnswerCode: string;
    HolidayChildcareAnswerCode: string;
    Editable?: boolean;
  }
  